var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("\n    "+_vm._s(_vm.heatmap.name)+"\n  ")]),_c('table',[_c('tbody',_vm._l((_vm.rows),function([name, color]){return _c('tr',{key:name},[_c('td',[_vm._v("\n          "+_vm._s(name)+"\n        ")]),_c('td',{style:({ paddingLeft: '10px' })},[_c('div',{style:({
              width: '30px',
              height: '15px',
              backgroundColor: color
            })})])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }